import { useQuery } from "@tanstack/react-query"
import type { CustomChart } from "@tokenterminal/tt-analytics-api-types/dist/api/customChart"
import { apiGET } from "../../../api/api-get"
import { generateId } from "../utils/generate-id"
import { getProjectsFromFilters } from "../utils/get-projects-from-filter"

const emptyConfig = {
  configs: [],
  zoom: "180d",
  granularity: "day",
} as unknown as CustomChart

async function fetchChartConfig(configId: string) {
  const { data: result } = await apiGET(`/v3/internal/configs/${configId}`)

  if (result.type !== "chart") {
    throw new Error("Invalid config type")
  }

  ;(result.config as CustomChart).configs.forEach((config) => {
    if (!config.filters) {
      config.filters = [
        {
          type: "project",
          values: config.projects ?? [],
          comparator: "in",
        },
      ]
    }

    config.visible =
      typeof config.visible === "undefined"
        ? getProjectsFromFilters(config.filters)
        : config.visible
    config.visible = config.visible.map((item) => {
      return item.startsWith(config.id) ? item : generateId(config.id, item)
    })
  })

  return result.config as CustomChart
}

/** A saved chart config. Returns an empty config while it loads. */
export function useChartConfigById(configId: string) {
  const { data } = useQuery({
    queryKey: ["chartConfigById", configId],
    queryFn: () => fetchChartConfig(configId),
    // Configs are immutable, so fetch once: a failed background refetch
    // must not throw away a chart that already rendered.
    staleTime: Infinity,
    throwOnError: true,
  })

  return data ?? emptyConfig
}
